import { Boxes, Loader2, Ruler, X } from "lucide-react";
import { Button } from "../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

const BRANDS = [["bhoruka", "Curtain wall · Bhoruka"], ["bway", "Curtain wall · BWAY"]];
const lvl = (z) => `${z >= 0 ? "+" : ""}${z}`;
const Row = ({ k, v, testid }) => <div className="flex justify-between gap-3 text-xs"><span className="text-zinc-500">{k}</span><span className="font-mono text-zinc-200" data-testid={testid}>{v}</span></div>;

const ElevBtn = ({ onClick }) => (
  <Button data-testid="model-zone-card-elevation-btn" size="sm" variant="outline" onClick={onClick} className="border-zinc-700"><Ruler className="mr-1.5 h-3.5 w-3.5" />Elevation</Button>
);

export const ZoneCard = ({ zone, sky, brand, setBrand, onDesign, onElevation, onClose, busy }) => {
  const it = zone || sky;
  if (!it) return null;
  const done = !!it.design_id;
  return (
    <div className="space-y-2 rounded-lg border border-sky-500/30 bg-[#121215] p-3" data-testid="model-zone-card">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 font-[Manrope] text-sm font-bold text-white">
          {zone && <span className="inline-block h-3 w-3 rounded-sm" style={{ background: zone.color }} />}
          <span data-testid="model-zone-card-label">{it.label}</span>
          <span className="rounded bg-zinc-800 px-1.5 py-0.5 font-mono text-[10px] text-zinc-400">{zone ? zone.suggested_system.replace("_", " ") : "skylight"}</span>
        </div>
        <button onClick={onClose} data-testid="model-zone-card-close" className="text-zinc-500 transition-colors hover:text-white"><X className="h-4 w-4" /></button>
      </div>
      {zone ? (
        <div className="grid gap-1 sm:grid-cols-2 sm:gap-x-6">
          <Row k="Facade area" v={`${zone.area_m2} m²`} testid="model-zone-card-area" />
          <Row k="Glazed / opaque" v={`${zone.glazed_m2} / ${zone.opaque_m2} m²`} />
          <Row k="Extent × height" v={`${zone.extent_m} × ${zone.height_m} m`} />
          <Row k="Level" v={`${zone.level_name || zone.level} · ${lvl(zone.z0)} → ${lvl(zone.z1)} m`} />
          <div className="col-span-full text-[11px] text-zinc-400">{Object.entries(zone.materials).slice(0, 4).map(([k, v]) => `${k} ${v} m²`).join(" · ")}</div>
        </div>
      ) : (
        <div className="grid gap-1 sm:grid-cols-2 sm:gap-x-6">
          <Row k="Area" v={`${sky.area_m2} m²`} testid="model-zone-card-area" />
          <Row k="Plan" v={`${sky.plan_length_m} × ${sky.plan_width_m} m`} />
          <Row k="Slope" v={`${sky.slope_deg}°`} />
          <Row k="Top" v={`${lvl(sky.z_m)} m`} />
        </div>
      )}
      {done ? (
        <div className="flex flex-wrap items-center gap-3">
          <span className="text-xs text-emerald-400" data-testid="model-zone-card-designed">✓ Designed — open it in the Systems tab</span>
          {zone && onElevation && <ElevBtn onClick={onElevation} />}
        </div>
      ) : (
        <div className="flex flex-wrap items-center gap-2 pt-1">
          {zone && (
            <Select value={brand || "bhoruka"} onValueChange={setBrand}>
              <SelectTrigger data-testid="model-zone-card-brand" className="h-8 w-52 border-zinc-800 bg-zinc-900 text-xs"><SelectValue /></SelectTrigger>
              <SelectContent>{BRANDS.map(([v, l]) => <SelectItem key={v} value={v} className="text-xs">{l}</SelectItem>)}</SelectContent>
            </Select>
          )}
          <Button data-testid="model-zone-card-design-btn" size="sm" disabled={busy} onClick={onDesign} className="bg-amber-500 text-black hover:bg-amber-400">
            {busy ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <Boxes className="mr-1.5 h-3.5 w-3.5" />}Design this {zone ? "zone" : "skylight"}
          </Button>
          {zone && onElevation && <ElevBtn onClick={onElevation} />}
        </div>
      )}
    </div>
  );
};
